(function () {
  'use strict';

  var allProductData = {};

  function loadAllData() {
    var els = document.querySelectorAll('[id^="backorder-variant-data-"]');
    els.forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        allProductData[String(data.productId)] = data;
      } catch (e) {
        console.error('[backorder-pdp] JSON parse error:', e);
      }
    });
  }

  function applyState(variantId, productId) {
    var data = allProductData[String(productId)];
    if (!data) return;
    var vd = data.variants[String(variantId)];
    if (!vd) {
      console.warn('[backorder-pdp] No data for variant:', variantId);
      return;
    }
    var isActive = vd.backorder_enabled === true && vd.inventory_quantity <= 0;
    updateButton(isActive, productId, vd);
    updateMessage(isActive, vd, productId);
    updatePriceBadge(isActive, productId);
  }

  function updateButton(isActive, productId, variantData) {
    var form = document.querySelector('#product-form-' + productId);
    if (!form) return;
    var btn = form.querySelector('[data-add-to-cart-trigger]');
    if (!btn) return;
    var preorderLabel = btn.getAttribute('data-preorder-label') || 'Pre Order';

    if (!isActive) {
      btn.classList.remove('button--preorder');
      return;
    }

    btn.removeAttribute('disabled');
    btn.classList.remove('disabled');
    btn.classList.add('button--preorder');

    var span = btn.querySelector('.text');
    if (!span) span = btn.querySelector('span:not(.icon)');
    if (span) span.textContent = preorderLabel;

    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput) variantInput.disabled = false;
  }

  function updateMessage(isActive, variantData, productId) {
    var wrapper = document.getElementById('backorder-message-' + productId);
    if (!wrapper) return;
    if (!isActive) {
      wrapper.hidden = true;
      return;
    }
    var date = variantData.display_date || '';
    var dateEl = wrapper.querySelector('.preorder-badge__date-value');
    var datePara = wrapper.querySelector('.preorder-badge__date');
    if (dateEl) dateEl.textContent = date;
    if (datePara) datePara.hidden = !date;
    wrapper.hidden = false;
  }

  function updatePriceBadge(isActive, productId) {
    var badge = document.getElementById('preorder-price-badge-' + productId);
    if (!badge) return;
    badge.classList.toggle('is-hidden', !isActive);
  }

  function patchSelectCallback() {
    if (!window.selectCallback || window.selectCallback._backorderPatched) return;

    var original = window.selectCallback;
    window.selectCallback = function ($product, product, variant, state) {
      original.call(this, $product, product, variant, state);

      if (!product || !variant) return;

      var productId = String(product.id);
      if (!allProductData[productId]) return;

      setTimeout(function () {
        applyState(variant.id, productId);
      }, 0);
    };
    window.selectCallback._backorderPatched = true;
  }

  function applyInitialState() {
    Object.keys(allProductData).forEach(function (productId) {
      var form = document.querySelector('#product-form-' + productId);
      var input = form && form.querySelector('input[name="id"]');
      if (input && input.value) {
        applyState(input.value, productId);
      }
    });
  }

  function init() {
    loadAllData();
    if (Object.keys(allProductData).length === 0) return;

    applyInitialState();
    patchSelectCallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
